import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Fade out and remove the in-HTML splash once React has mounted.
// Hold briefly so the splash feels deliberate on fast launches, then fade.
const splash = document.getElementById('app-splash');
if (splash) {
  window.setTimeout(() => splash.classList.add('fade-out'), 400);
  window.setTimeout(() => splash.remove(), 700);
}

// Service worker registration is now handled by ServiceWorkerContext
// which provides update notifications to users

// Report web vitals (optional - for performance monitoring)
reportWebVitals();
